import { createFileRoute } from "@tanstack/react-router";
import { Chip, Table } from "@heroui/react";

import {
  chargeTypeTitles,
  formatOptionPrice,
  PackageOptionEntity,
} from "@/features/package-options/type.ts";
import { usePackageOptions } from "@/features/package-options/use-package-options.ts";
import { PackageOptionModal } from "@/features/package-options/ui/package-option-modal.tsx";
import { DeletePackageOptionModal } from "@/features/package-options/ui/delete-package-option-modal.tsx";

export const Route = createFileRoute("/dashboard/package-options")({
  component: RouteComponent,
});

function RouteComponent() {
  const { data } = usePackageOptions();

  return (
    <div className="flex flex-col pt-4">
      <div className="flex flex-row gap-2 justify-between h-12 items-center">
        <p className="font-bold text-xl">Опции упаковки и доп. услуги</p>

        <PackageOptionModal />
      </div>

      <p className="mt-2 text-sm text-default-500">
        Опция начисляется на каждое место заказа, к которому её выбрали.
      </p>

      <Table.Root className="mt-8">
        <Table.Content aria-label="Список опций упаковки">
          <Table.Header>
            <Table.Column>Название</Table.Column>
            <Table.Column>Код</Table.Column>
            <Table.Column>Размеры</Table.Column>
            <Table.Column>Начисление</Table.Column>
            <Table.Column>Цена</Table.Column>
            <Table.Column>Примечание</Table.Column>
            <Table.Column>Статус</Table.Column>
            <Table.Column> </Table.Column>
          </Table.Header>
          <Table.Body items={data?.data ?? []}>
            {(option: PackageOptionEntity) => (
              <Table.Row id={String(option.id)}>
                <Table.Cell>{option.name}</Table.Cell>
                <Table.Cell>{option.type}</Table.Cell>
                <Table.Cell>{option.dimensions || "—"}</Table.Cell>
                <Table.Cell>{chargeTypeTitles[option.chargeType]}</Table.Cell>
                <Table.Cell>{formatOptionPrice(option)}</Table.Cell>
                <Table.Cell>{option.description || "—"}</Table.Cell>
                <Table.Cell>
                  <Chip
                    color={option.isActive ? "success" : "danger"}
                    size="sm"
                    variant="soft"
                  >
                    {option.isActive ? "Активна" : "Скрыта"}
                  </Chip>
                </Table.Cell>
                <Table.Cell>
                  <div className="flex flex-row gap-2 justify-end">
                    <PackageOptionModal option={option} />

                    <DeletePackageOptionModal optionId={option.id} />
                  </div>
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table.Content>
      </Table.Root>
    </div>
  );
}
